import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default class Image extends CatalogObjectSerializer {}